
import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import {Link} from "react-router-dom"; 
import $ from 'jquery';
import editImg from "../images/edit.png"
import deleteImg from "../images/delete.png"

export default class Userlist extends Component {
    render() {

    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content">    
        <Menu></Menu>    
          <div className="content-right-wrapper">
            <div className="container">
              <div className='form-wrapper'>
                <div className='form-head'>
                  User Add
                  <Link to="/UserAdd"><button className='addNewBtn btn'>Add New</button></Link>
                </div>
                <div className='table'>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">First</th>
                        <th scope="col">Last</th>
                        <th scope="col">Handle</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">1</th>
                        <td>Mark</td>
                        <td>Otto</td>
                        <td>@mdo</td>
                        <td>
                          <img src={editImg} className='actionIcon'></img>
                          <img src={deleteImg} className='actionIcon'></img>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">2</th>
                        <td>Jacob</td>
                        <td>Thornton</td>
                        <td>@fat</td>
                      </tr>
                      <tr>
                        <th scope="row">3</th>
                        <td colspan="2">Larry the Bird</td>
                        <td>@twitter</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <nav aria-label="Page navigation example">
                    <ul className="pagination justify-content-end">
                      <li className="page-item">
                        <a className="page-link" href="#" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span className="sr-only">Previous</span>
                        </a>
                      </li>
                      <li className="page-item"><a className="page-link" href="#">1</a></li>
                      <li className="page-item"><a className="page-link" href="#">2</a></li>
                      <li className="page-item"><a className="page-link" href="#">3</a></li>
                      <li className="page-item">
                        <a className="page-link" href="#" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span className="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
            
          </div>
        </div>
        
        <Footer></Footer>
      </div>
      )
    }
}


// WEBPACK FOOTER //
// ./src/admin/userlist.jsx